import { render, staticRenderFns } from "./SecretariaVirtual.vue?vue&type=template&id=1038f9bd&scoped=true"
import script from "./SecretariaVirtual.vue?vue&type=script&lang=js"
export * from "./SecretariaVirtual.vue?vue&type=script&lang=js"
import style0 from "./SecretariaVirtual.vue?vue&type=style&index=0&id=1038f9bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038f9bd",
  null
  
)

export default component.exports